export default function StudioPreviewStatusPill(props: {
  status: "ready" | "blocked" | "rendered" | "loading" | "warn";
  label: string;
}) {
  const tone =
    props.status === "blocked"
      ? {
          background: "rgba(162, 62, 62, 0.12)",
          color: "#812d2d",
          dot: "#a23e3e",
        }
      : props.status === "loading" || props.status === "warn"
        ? {
            background: "rgba(181, 141, 34, 0.16)",
            color: "#6d5210",
            dot: "#8f6e16",
          }
        : {
            background: "rgba(44, 93, 67, 0.14)",
            color: "#214735",
            dot: "#2c5d43",
          };

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        padding: "0.28rem 0.64rem",
        borderRadius: 999,
        background: tone.background,
        color: tone.color,
        fontSize: "0.74rem",
        fontWeight: 700,
        textTransform: "capitalize",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 8,
          height: 8,
          borderRadius: 999,
          background: tone.dot,
        }}
      />
      {props.label}
    </span>
  );
}
